import {
  __decorateClass
} from "./chunk-EUXUH3YW.js";

// libs/widgets/src/lib/notifications/i18n/index.ts
import { addTranslation } from "@one-inch-community/core/lit";
addTranslation({
  en: () => import("./en-LH2H6NI6.js").then((m) => m.default),
  ar: () => import("./ar-5E2DVKJM.js").then((m) => m.default),
  fr: () => import("./fr-HW5JB3YP.js").then((m) => m.default),
  es: () => import("./es-H5L7GO7Q.js").then((m) => m.default),
  de: () => import("./de-6LJ5U5KP.js").then((m) => m.default)
});

// libs/widgets/src/lib/notifications/notifications-controller.ts
import { html as html8, render as render2 } from "lit";

// libs/widgets/src/lib/notifications/elements/notifications-desktop-container/notifications-desktop-container.element.ts
import { html as html4 } from "lit";
import { customElement as customElement2 } from "lit/decorators.js";

// libs/widgets/src/lib/notifications/elements/notifications-desktop-container/notifications-desktop-container.style.ts
import { css } from "lit";
var notificationsDesktopContainerStyle = css`

    :host {
        --offset: 72px;
        position: fixed;
        z-index: 1000;
        margin-bottom: var(--offset);
        padding-top: var(--offset);
        padding-bottom: 8px;
        padding-right: 8px;
        box-sizing: border-box;
        top: 0;
        right: 0;
        height: 100vh;
        width: 300px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        overflow-x: hidden;
        pointer-events: none;
    }
    
    .close-button-container {
        display: flex;
    }

`;

// libs/widgets/src/lib/notifications/elements/notifications-desktop-container/notifications-desktop-container.element.ts
import { getScrollbarStyle } from "@one-inch-community/core/theme";
import "@one-inch-community/ui-components/icon";
import "@one-inch-community/ui-components/button";
import { animationMap, appendStyle as appendStyle3, subscribe as subscribe3 } from "@one-inch-community/core/lit";
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  fromEvent as fromEvent2,
  map,
  merge,
  startWith,
  switchMap as switchMap3,
  takeUntil as takeUntil2,
  tap as tap2,
  timer
} from "rxjs";

// libs/widgets/src/lib/notifications/elements/notifications-desktop-container/notification-animation-map-controller.ts
import { appendStyle as appendStyle2 } from "@one-inch-community/core/lit";
import "@one-inch-community/ui-components/icon";
import "@one-inch-community/ui-components/button";

// libs/widgets/src/lib/notifications/elements/notifications-base-container/notifications-base-container.element.ts
import { html, LitElement } from "lit";
import { subscribe, getMobileMatchMediaEmitter } from "@one-inch-community/core/lit";
import { skip, switchMap } from "rxjs";
var NotificationsBaseContainerElement = class extends LitElement {
  constructor() {
    super();
    this.notifications = [];
    this.animationInProgress = false;
    this.animationStateQueue = [];
    this.fullView = false;
    this.countShortView = 0;
  }
  connectedCallback() {
    super.connectedCallback();
    subscribe(this, [
      getMobileMatchMediaEmitter().pipe(
        skip(1),
        switchMap(() => this.controller.closeNotifications())
      )
    ], { requestUpdate: false });
  }
  setController(controller) {
    this.controller = controller;
  }
  setAllNotifications(notifications) {
    if (this.animationInProgress) {
      this.animationStateQueue.push(notifications);
      return;
    }
    this.notifications = notifications;
    if (!this.fullView && this.countShortView < this.maxShorthandView) {
      this.countShortView++;
    }
    this.requestUpdate();
  }
  animationStartHandler() {
    this.animationInProgress = true;
  }
  animationCompleteHandler() {
    this.animationInProgress = false;
    const newState = this.animationStateQueue.shift();
    if (newState) {
      this.notifications = newState;
      this.requestUpdate();
    }
  }
  openAll() {
    this.onShowAll();
  }
  onShowAll() {
    this.fullView = true;
    this.requestUpdate();
  }
  async closeNotification(id) {
    await this.controller.removeNotification(id);
  }
  makeNotificationTemplate(record) {
    const template = html`${record.element}`;
    if (record.config.customTemplate) return html`${template}`;
    return html`
      <div class="notification-template">${template}</div>
    `;
  }
  getSortedNotifications() {
    const result = this.notifications;
    if (this.fullView) {
      return result;
    }
    return [...result.slice(0, this.countShortView)];
  }
};

// libs/widgets/src/lib/notifications/elements/notifications-base-container/notifications-base-container.style.ts
import { css as css2 } from "lit";
var notificationsBaseContainerStyle = css2`

    .close-button-container {
        pointer-events: all;
        margin-left: auto;
    }

    .notification-close-container {
        position: relative;
    }

    .close-notification-button {
        pointer-events: all;
        position: absolute;
        top: -8px;
        right: -8px;
        transform: scale(0);
        transition: transform .2s;
    }
    
    .notification-template {
        font-size: 14px;
    }
    
    .show-all-button {
        pointer-events: all;
    }

    @media (hover: hover) {
        .notification-container:hover {
            border: 1px solid var(--primary-50);
        }

        .notification-close-container:hover .close-notification-button {
            transform: scale(1);
        }
    }

`;

// libs/widgets/src/lib/notifications/elements/notifications-base-container/notification-animation-map-base-controller.ts
import { html as html3 } from "lit";

// libs/widgets/src/lib/notifications/elements/notification-view/notification-view.element.ts
import { html as html2, LitElement as LitElement2 } from "lit";
import { customElement, property } from "lit/decorators.js";

// libs/widgets/src/lib/notifications/elements/notification-view/notification-view.style.ts
import { css as css3 } from "lit";
import { mobileMediaCSS } from "@one-inch-community/core/lit";
var notificationViewStyle = css3`

    :host {
        position: relative;
        display: block;
    }

    .notification-container {
        --border-color: var(--primary-12);
        pointer-events: all;
        color: var(--color-content-content-primary);
        background-color: var(--color-background-bg-primary);
        border-radius: 8px;
        padding: 8px;
        box-sizing: border-box;
        width: 100%;
        min-height: 50px;
        border: 1px solid var(--border-color);
        transition: border .2s;
    }

    .notification-title {
        font-size: 16px;
        padding-bottom: 4px;
        display: flex;
    }

    .notification-time {
        font-size: 11px;
        color: var(--color-content-content-secondary);
        margin-left: auto;
    }

    .notification-time:dir(rtl) {
        margin-left: 0;
        margin-right: auto;
    }
    
    .error {
        --border-color: var(--color-background-bg-critical);
    }
    
    .warning {
        --border-color: var(--color-background-bg-warning);
    }

    .close-notification-button {
        pointer-events: all;
        position: absolute;
        top: -8px;
        right: -8px;
        transform: scale(0);
        transition: transform .2s;
    }

    @media (hover: hover) {
        .notification-container:hover {
            --border-color: var(--primary-50);
        }
        
        .notification-container.error:hover {
            --border-color: var(--color-background-bg-critical-hover);
        }

        .notification-container.warning:hover {
            --border-color: var(--color-background-bg-warning-hover);
        }
        
        .notification-container:hover .close-notification-button {
            transform: scale(1);
        }
    }
    
    ${mobileMediaCSS(css3`
        :host {
            width: calc(100vw - 16px);
        }
    `)}

`;

// libs/widgets/src/lib/notifications/elements/notification-view/notification-view.element.ts
import { appendStyle, dispatchEvent, subscribe as subscribe2 } from "@one-inch-community/core/lit";
import "@one-inch-community/ui-components/icon";
import "@one-inch-community/ui-components/button";
import { fromEvent, switchMap as switchMap2, takeUntil, tap } from "rxjs";
import { classMap } from "lit/directives/class-map.js";
var NotificationViewElement = class extends LitElement2 {
  constructor() {
    super(...arguments);
    this.isClose = false;
  }
  connectedCallback() {
    super.connectedCallback();
    subscribe2(this, [
      this.onTouch()
    ], { requestUpdate: false });
  }
  render() {
    const classes = {
      "notification-container": true,
      "warning": this.config?.warningStyle ?? false,
      "error": this.config?.errorStyle ?? false
    };
    return html2`
      <div class="${classMap(classes)}">
        <div>
          <inch-button class="close-notification-button" @click="${() => dispatchEvent(this, "closeNotification", null)}" size="l" type="secondary">
            <inch-icon icon="cross8"></inch-icon>
          </inch-button>
        </div>
        <div class="notification-title">
          <span>${this.config?.title}</span>
          <div class="notification-time">${this.formatNotificationTime(this.timestamp)}</div>
        </div>
        <slot></slot>
      </div>
    `;
  }
  onTouch() {
    let distance = 0;
    return fromEvent(this, "touchstart").pipe(
      switchMap2((startEvent) => {
        const startPoint = startEvent.touches[0].clientX;
        return fromEvent(document, "touchmove").pipe(
          tap((event) => {
            if (this.isClose) return;
            const currentPoint = event.touches[0].clientX;
            distance = currentPoint - startPoint;
            appendStyle(this, {
              transform: `translate3d(${distance}px, 0, 0)`
            });
            if (Math.abs(distance) > window.innerWidth * 0.3) {
              this.onClose(distance).catch();
            }
          }),
          takeUntil(fromEvent(document, "touchend").pipe(
            switchMap2(() => this.onResetPosition(distance))
          ))
        );
      })
    );
  }
  async onResetPosition(lastPosition) {
    if (this.isClose) return;
    await this.animate([
      { transform: `translate3d(${lastPosition}px, 0, 0)` },
      { transform: `translate3d(0, 0, 0)` }
    ], { duration: 200 }).finished;
    appendStyle(this, {
      transform: ""
    });
  }
  async onClose(lastPosition) {
    this.isClose = true;
    dispatchEvent(this, "closeNotification", null);
    await this.animate([
      { transform: `translate3d(${lastPosition}px, 0, 0)` },
      { transform: `translate3d(${lastPosition * 10}px, 0, 0)` }
    ], { duration: 200 }).finished;
    appendStyle(this, {
      transform: `translate3d(${lastPosition * 10}px, 0, 0)`
    });
  }
  formatNotificationTime(timestamp) {
    const date = new Date(timestamp);
    const formatTimeValue = (value) => {
      return value < 10 ? "0" + value : value;
    };
    const timeView = [
      formatTimeValue(date.getHours()),
      formatTimeValue(date.getMinutes()),
      formatTimeValue(date.getSeconds())
    ].join(":");
    if (Date.now() - timestamp > 6 * 60 * 60 * 1e3) {
      const dateView = [
        formatTimeValue(date.getDate()),
        formatTimeValue(date.getMonth() + 1)
      ].join(".");
      return [dateView, timeView].join(" ");
    }
    return timeView;
  }
};
NotificationViewElement.tagName = "inch-notification-view";
NotificationViewElement.styles = notificationViewStyle;
__decorateClass([
  property({ type: Object })
], NotificationViewElement.prototype, "config", 2);
__decorateClass([
  property({ type: Number })
], NotificationViewElement.prototype, "timestamp", 2);
NotificationViewElement = __decorateClass([
  customElement(NotificationViewElement.tagName)
], NotificationViewElement);

// libs/widgets/src/lib/notifications/elements/notifications-base-container/notification-animation-map-base-controller.ts
var animationOptions = {
  duration: 500,
  easing: "cubic-bezier(.2, .8, .2, 1)"
};
var NotificationAnimationMapBaseController = class {
  constructor(element) {
    this.element = element;
    this.direction = "vertical";
    this.vertical = "notification-item";
    this.renderElements = null;
    this.removeElementsClientHeight = null;
    this.moveElements = null;
    this.animationOptions = animationOptions;
  }
  onKeyExtractor([id, record]) {
    if (id === "fullView") {
      return "item-" + id;
    }
    const date = new Date(record.timestamp);
    return "item-" + id + `_${[date.getMinutes(), date.getSeconds()].join("-")}`;
  }
  onTemplateBuilder([id, record]) {
    if (id === "fullView") {
      return html3`
        <inch-button @click="${() => this.element.openAll()}" class="show-all-button" fullSize size="l" type="secondary">
          <inch-icon icon="arrowDown24"></inch-icon>
        </inch-button>
      `;
    }
    return html3`
      <inch-notification-view timestamp="${record.timestamp}" .config="${record.config}" @closeNotification="${() => this.element.closeNotification(id)}">
        ${this.element.makeNotificationTemplate(record)}
      </inch-notification-view>
    `;
  }
  onAnimationStart() {
    this.element.animationStartHandler();
  }
  onAnimationComplete() {
    this.element.animationCompleteHandler();
  }
  async onBeforeAnimation(container, renderElements, removeElements, moveElements) {
    this.renderElements = renderElements;
    this.removeElementsClientHeight = /* @__PURE__ */ new Map();
    removeElements.forEach((element, index) => {
      this.removeElementsClientHeight.set(index, element.clientHeight);
    });
    this.moveElements = moveElements;
  }
  async onAfterAnimation() {
    this.renderElements = null;
    this.removeElementsClientHeight = null;
    this.moveElements = null;
  }
  async onAfterRenderAnimateItem(element, index) {
    const reset = () => {
      this.onAfterRenderAnimateItemSkipTransition(element, index);
    };
    if (this.element.scrollTop >= this.topOffset) {
      reset();
      return;
    }
    const rect = element.getBoundingClientRect();
    if (rect.top + rect.height - this.topOffset > window.innerHeight) {
      reset();
      return;
    }
    await this.onAfterRenderAnimateItemTransition(element, index);
    reset();
  }
  async onBeforeMoveAnimationItem(element, oldIndex, newIndex) {
    return newIndex;
  }
  getOffsetByIndex(index) {
    let offset = null;
    this.moveElements?.forEach((element, [oldIndex, newIndex]) => {
      if (index - 1 === newIndex) {
        offset = element.clientHeight * (oldIndex > newIndex ? -1 : 1);
      }
    });
    if (offset === null && this.removeElementsClientHeight) {
      const newNode = this.renderElements?.get(0);
      offset = newNode?.clientHeight ?? null;
    }
    if (offset === null && this.removeElementsClientHeight) {
      this.removeElementsClientHeight.forEach((clientHeight, removeIndex) => {
        if (removeIndex === index) {
          offset = clientHeight * -1;
        }
      });
    }
    return offset ?? 0;
  }
};

// libs/widgets/src/lib/notifications/elements/notifications-desktop-container/notification-animation-map-controller.ts
var NotificationAnimationMapController = class extends NotificationAnimationMapBaseController {
  constructor(element) {
    super(element);
    this.topOffset = 100;
  }
  async onBeforeRemoveAnimateItem(element) {
    if (element.id === this.onKeyExtractor(["fullView", null])) {
      element.animate([
        { opacity: 1 },
        { opacity: 0 }
      ], { ...this.animationOptions, duration: 150 });
      return;
    }
    await element.animate([
      { transform: "translateX(0)" },
      { transform: "translateX(110%)" }
    ], this.animationOptions).finished;
  }
  async onBeforeRenderAnimateItem(element) {
    appendStyle2(element, {
      transform: "translateX(110%)"
    });
  }
  async onAfterMoveAnimationItem(element, newIndex) {
    const rect = element.getBoundingClientRect();
    if (rect.top > window.innerHeight + this.topOffset) {
      return;
    }
    const offset = this.getOffsetByIndex(newIndex);
    await element.animate([
      { transform: `translateY(${offset * -1}px)` },
      { transform: `translateY(0)` }
    ], this.animationOptions).finished;
  }
  async onAfterRenderAnimateItemTransition(element, index) {
    const offset = 100 + index * 50;
    await element.animate([
      { transform: `translateX(${offset}%)` },
      { transform: "translateX(0)" }
    ], { ...this.animationOptions, duration: this.animationOptions.duration + index * 50 }).finished;
  }
  onAfterRenderAnimateItemSkipTransition(element) {
    appendStyle2(element, {
      transform: ""
    });
  }
};

// libs/widgets/src/lib/notifications/elements/notifications-desktop-container/notifications-desktop-container.element.ts
var animationOptions2 = {
  duration: 500,
  easing: "cubic-bezier(.2, .8, .2, 1)"
};
var NotificationsDesktopContainerElement = class extends NotificationsBaseContainerElement {
  constructor() {
    super(...arguments);
    this.isClose = false;
    this.maxShorthandView = 4;
    this.animationController = new NotificationAnimationMapController(this);
  }
  connectedCallback() {
    super.connectedCallback();
    let prevDelta = 0;
    subscribe3(this, [
      merge(
        getInteractiveCloseStreamByScrollEvent(this),
        getInteractiveCloseStreamByTouchEvent(this)
      ).pipe(
        filter(() => !this.isClose),
        tap2((delta) => {
          if (Math.abs(delta - prevDelta) > 10 && delta === 0) {
            this.animate([
              { transform: `translate3d(${prevDelta}px, 0, 0)` },
              { transform: `translate3d(0, 0, 0)` }
            ], { ...animationOptions2, delay: 200 }).finished.then(() => {
              appendStyle3(this, {
                transform: ""
              });
            });
            prevDelta = delta;
            return;
          }
          if (delta * 100 / this.clientWidth > 50) {
            this.isClose = true;
            this.animate([
              { transform: `translate3d(${delta}px, 0, 0)` },
              { transform: `translate3d(100%, 0, 0)` }
            ], animationOptions2).finished.then(() => {
              appendStyle3(this, {
                transform: `translate3d(100%, 0, 0)`
              });
              return this.controller.closeNotifications();
            });
            return;
          }
          appendStyle3(this, {
            transform: `translate3d(${delta}px, 0, 0)`
          });
          prevDelta = delta;
        })
      )
    ], { requestUpdate: false });
  }
  preRender() {
    appendStyle3(this, {
      transform: "translateX(100%)"
    });
  }
  async postRender() {
    await this.animate([
      { transform: "translateX(100%)" },
      { transform: "translateX(0)" }
    ], animationOptions2).finished;
    appendStyle3(this, {
      transform: ""
    });
  }
  async preClose() {
    if (this.isClose) return;
    await this.animate([
      { transform: "translateX(0)" },
      { transform: "translateX(100%)" }
    ], animationOptions2).finished;
    appendStyle3(this, {
      transform: "translateX(100%)"
    });
  }
  render() {
    return html4`
      <div class="close-button-container">
        <inch-button @click="${() => this.controller.removeNotifications()}" size="l" type="tertiary-gray">
          <inch-icon icon="trash16"></inch-icon>
        </inch-button>
        <inch-button @click="${() => this.controller.closeNotifications()}" size="l" type="tertiary-gray">
          <inch-icon icon="xCircle16"></inch-icon>
        </inch-button>
      </div>
      ${animationMap(
      this.getSortedNotifications(),
      this.animationController
    )}
    `;
  }
  getSortedNotifications() {
    const result = super.getSortedNotifications();
    if (!this.fullView) {
      return [...result, ["fullView"]];
    }
    return result;
  }
};
NotificationsDesktopContainerElement.tagName = "inch-notifications-desktop-container";
NotificationsDesktopContainerElement.styles = [
  getScrollbarStyle(":host", true),
  notificationsBaseContainerStyle,
  notificationsDesktopContainerStyle
];
NotificationsDesktopContainerElement = __decorateClass([
  customElement2(NotificationsDesktopContainerElement.tagName)
], NotificationsDesktopContainerElement);
function getInteractiveCloseStreamByScrollEvent(element) {
  let offsetX = 0;
  let offsetY = 0;
  let fullOverflow = false;
  const initialResistance = 5e4;
  const resistanceThreshold = 1;
  const reset = () => {
    offsetX = 0;
    offsetY = 0;
    fullOverflow = false;
  };
  const applyBounceEffect = (offset) => {
    if (offset < 0) {
      const resistance = (element.clientWidth - offset) * 0.02;
      if (resistance > 12) {
        fullOverflow = true;
      }
      return resistanceThreshold / initialResistance + (offset - resistanceThreshold) / resistance;
    }
    return offset;
  };
  return fromEvent2(document, "wheel").pipe(
    filter((event) => event.deltaMode === event.DOM_DELTA_PIXEL),
    map((event) => {
      if (fullOverflow) {
        event.stopPropagation();
      }
      offsetX = offsetX + event.deltaX;
      offsetY = offsetY + event.deltaY;
      if (Math.abs(offsetX) - Math.abs(offsetY) < 0) {
        return 0;
      }
      return offsetX * -1;
    }),
    switchMap3((offset) => {
      if (offset === 0) {
        reset();
        return [0];
      }
      return timer(100).pipe(
        map(() => {
          reset();
          return 0;
        }),
        startWith(applyBounceEffect(offset))
      );
    }),
    distinctUntilChanged()
  );
}
function getInteractiveCloseStreamByTouchEvent(element) {
  const end$ = fromEvent2(document, "touchend");
  const initialResistance = 5e4;
  const resistanceThreshold = 1;
  const applyBounceEffect = (offset) => {
    if (offset < 0) {
      const resistance = (element.clientWidth - offset) * 0.02;
      return resistanceThreshold / initialResistance + (offset - resistanceThreshold) / resistance;
    }
    return offset;
  };
  return fromEvent2(element, "touchstart").pipe(
    switchMap3((startEvent) => {
      const startPoint = startEvent.touches[0].clientX;
      return fromEvent2(document, "touchmove").pipe(
        map((event) => event.touches[0].clientX - startPoint),
        switchMap3((offset) => end$.pipe(
          map(() => 0),
          startWith(applyBounceEffect(offset))
        )),
        takeUntil2(end$.pipe(debounceTime(100)))
      );
    })
  );
}

// libs/widgets/src/lib/notifications/elements/notifications-mobile-container/notifications-mobile-container.element.ts
import { html as html7, render } from "lit";
import { customElement as customElement4 } from "lit/decorators.js";

// libs/widgets/src/lib/notifications/elements/notifications-mobile-container/notifications-mobile-container.style.ts
import { css as css4 } from "lit";
var notificationsMobileContainerStyle = css4`

    :host {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 3000;
        display: grid;
        flex-direction: column;
        overflow-x: hidden;
    }

    .touch-container {
        position: relative;
        padding: 8px;
        box-sizing: border-box;
        max-width: 100vw;
   /*     transition: transform .2s;*/
    }
    
    .background-view {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        max-height: 100vh;
        transition: background-color .2s;
        z-index: -1000;
    }

    .info-view {
        display: flex;
        width: 100%;
        height: 48px;
    }
`;

// libs/widgets/src/lib/notifications/elements/notifications-mobile-container/notifications-mobile-container.element.ts
import {
  subscribe as subscribe4,
  appendStyle as appendStyle5,
  animationMap as animationMap2
} from "@one-inch-community/core/lit";

// libs/widgets/src/lib/notifications/elements/notifications-mobile-container/notification-animation-map-controller.ts
import { appendStyle as appendStyle4 } from "@one-inch-community/core/lit";
import "@one-inch-community/ui-components/icon";
import "@one-inch-community/ui-components/button";
import { html as html5 } from "lit";
var NotificationAnimationMapController2 = class extends NotificationAnimationMapBaseController {
  constructor(element) {
    super(element);
    this.topOffset = 200;
  }
  onTemplateBuilder([id, record]) {
    return html5`
      <inch-notification-view
        timestamp="${record.timestamp}"
        .config="${record.config}"
        @closeNotification="${() => this.element.closeNotification(id)}"
      >
        ${this.element.makeNotificationTemplate(record)}
      </inch-notification-view>
    `;
  }
  async onBeforeRemoveAnimateItem(element) {
    await element.animate([
      { transform: "translateY(0)" },
      { transform: "translateY(50px) scale(0.7)", opacity: 0 }
    ], this.animationOptions).finished;
  }
  async onBeforeRenderAnimateItem(element) {
    appendStyle4(element, {
      transform: "translateX(-110%)"
    });
  }
  async onAfterMoveAnimationItem(element, newIndex) {
    if (this.element.scrollTop >= this.topOffset) {
      return;
    }
    const rect = element.getBoundingClientRect();
    if (rect.top > window.innerHeight + this.topOffset) {
      return;
    }
    const offset = this.getOffsetByIndex(newIndex);
    await element.animate([
      { transform: `translateY(${offset * -1}px)` },
      { transform: `translateY(0)` }
    ], this.animationOptions).finished;
  }
  async onAfterRenderAnimateItemTransition(element, index) {
    const offset = 100 + index * 10;
    await element.animate([
      { transform: `translateY(${offset * -1}%)`, zIndex: `-${index}` },
      { transform: "translateY(0)", zIndex: `-${index}` }
    ], { ...this.animationOptions, duration: this.animationOptions.duration, delay: index * 200 }).finished;
  }
  onAfterRenderAnimateItemSkipTransition(element) {
    appendStyle4(element, {
      transform: ""
    });
  }
};

// libs/widgets/src/lib/notifications/elements/notifications-mobile-container/notifications-mobile-container.element.ts
import {
  map as map3,
  tap as tap3,
  fromEvent as fromEvent3,
  startWith as startWith2,
  switchMap as switchMap4,
  takeUntil as takeUntil3,
  Observable as Observable2,
  debounceTime as debounceTime2,
  distinctUntilChanged as distinctUntilChanged2,
  Subject,
  merge as merge2
} from "rxjs";
import { createRef, ref } from "lit/directives/ref.js";
import { getScrollbarStyle as getScrollbarStyle2 } from "@one-inch-community/core/theme";
import { consume as consume2 } from "@lit/context";
import { ApplicationContextToken as ApplicationContextToken2 } from "@one-inch-community/core/application-context";
import { getContainer } from "@one-inch-community/ui-components/overlay";

// libs/widgets/src/lib/notifications/elements/notifications-mobile-container/notifications-mobile-info.element.ts
import { customElement as customElement3 } from "lit/decorators.js";
import { html as html6, LitElement as LitElement3 } from "lit";
import "@one-inch-community/ui-components/icon";

// libs/widgets/src/lib/notifications/elements/notifications-mobile-container/notifications-mobile-info.style.ts
import { css as css5 } from "lit";
var notificationsMobileInfoStyle = css5`
    
    
    :host {
        width: 100%;
    }

    .grid-container {
        display: grid;
        width: 100%;
        height: 100%;
        grid-template-columns: auto 1fr;
        grid-template-rows: 1fr;
        grid-gap: 16px;
    }
    
    .address {
        padding-top: 8px;
        font-size: 16px;
        font-weight: 600;
        line-height: 32px;
        letter-spacing: 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
        height: fit-content;
        text-align: center;
        color: var(--color-content-content-primary);
        display: flex;
        gap: 8px;
        justify-content: flex-end;
        align-items: center;
    }


`;

// libs/widgets/src/lib/notifications/elements/notifications-mobile-container/notifications-mobile-info.element.ts
import { consume } from "@lit/context";
import { ApplicationContextToken } from "@one-inch-community/core/application-context";
import { ChainId } from "@one-inch-community/models";
import { defer, map as map2 } from "rxjs";
import { formatHex } from "@one-inch-community/core/formatters";
import { observe } from "@one-inch-community/core/lit";
var chainIdIcons = {
  [ChainId.eth]: "eth24",
  [ChainId.bnb]: "bnb24",
  [ChainId.matic]: "matic24",
  [ChainId.op]: "op24",
  [ChainId.arbitrum]: "arbitrum24",
  [ChainId.gnosis]: "gnosis24",
  [ChainId.avalanche]: "avalanche24",
  [ChainId.fantom]: "fantom24",
  [ChainId.aurora]: "aurora24",
  [ChainId.klaytn]: "klaytn24",
  [ChainId.zkSyncEra]: "zkSyncEra24"
};
var NotificationsMobileInfoElement = class extends LitElement3 {
  constructor() {
    super(...arguments);
    this.addressView$ = defer(() => this.applicationContext.connectWalletController.data.activeAddress$).pipe(
      map2((address) => {
        if (!address) return "";
        const width = Math.max(Math.round(window.innerWidth / 25), 12);
        const head = Math.round(width / 2);
        const tail = width - head;
        return formatHex(address, { width, head, tail });
      })
    );
    this.chainIdIconName$ = defer(() => this.applicationContext.connectWalletController.data.chainId$).pipe(
      map2((chainId) => {
        if (!chainId) return "";
        return chainIdIcons[chainId];
      })
    );
  }
  render() {
    return html6`
      <div class="grid-container">
        <inch-icon icon="logoFull"></inch-icon>
        <div class="address">
          <span>${observe(this.addressView$)}</span>
        </div>
      </div>
    `;
  }
};
NotificationsMobileInfoElement.tagName = "inch-notifications-mobile-info";
NotificationsMobileInfoElement.styles = notificationsMobileInfoStyle;
__decorateClass([
  consume({ context: ApplicationContextToken })
], NotificationsMobileInfoElement.prototype, "applicationContext", 2);
NotificationsMobileInfoElement = __decorateClass([
  customElement3(NotificationsMobileInfoElement.tagName)
], NotificationsMobileInfoElement);

// libs/widgets/src/lib/notifications/elements/notifications-mobile-container/notifications-mobile-container.element.ts
var animationOptions3 = {
  duration: 500,
  easing: "cubic-bezier(.2, .8, .2, 1)"
};
var NotificationsMobileContainerElement = class extends NotificationsBaseContainerElement {
  constructor() {
    super(...arguments);
    this.maxShorthandView = 1;
    this.animationController = new NotificationAnimationMapController2(this);
    this.touchContainerRef = createRef();
    this.contentContainerRef = createRef();
    this.backgroundViewRef = createRef();
    this.upButtonElement = null;
    this.hostHeight = this.clientHeight;
    this.infoViewHeight = 48;
    //px
    this.open$ = new Subject();
    this.lastOffset = 0;
    this.closeInProgress = false;
    this.openInterpolation$ = this.open$.pipe(
      switchMap4(() => interpolateTo(10, this.infoViewHeight, 200))
    );
  }
  firstUpdated() {
    subscribe4(this, [
      this.onShowHideUpButton(),
      this.swipeDownOnShortViewHandler()
    ], { requestUpdate: false });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.upButtonElement?.remove();
  }
  render() {
    return html7`
      <div ${ref(this.backgroundViewRef)} class="background-view"></div>
      <div ${ref(this.touchContainerRef)} class="touch-container">
        <div class="info-view">
          <inch-notifications-mobile-info></inch-notifications-mobile-info>
        </div>
        <div ${ref(this.contentContainerRef)} class="content-view">
          ${animationMap2(
      this.getSortedNotifications(),
      this.animationController
    )}
        </div>
      </div>
    `;
  }
  async closeNotification(id) {
    if (this.fullView) {
      await this.controller.removeNotification(id);
      return;
    }
    await this.controller.closeNotifications();
  }
  openAll() {
    this.hostHeight = this.clientHeight;
    this.open$.next();
  }
  preRender() {
    appendStyle5(this, {
      transform: "translateY(-100%)"
    });
  }
  async postRender() {
    await this.animate([
      { transform: `translate3d(0, -100%, 0)` },
      { transform: `translate3d(0, ${-this.infoViewHeight}px, 0)` }
    ], animationOptions3).finished;
    appendStyle5(this, {
      transform: `translate3d(0, ${-this.infoViewHeight}px, 0)`
    });
  }
  async preClose() {
    this.closeInProgress = true;
    if (!this.fullView) {
      await this.touchContainerRef.value.animate([
        { transform: `translate3d(0, ${this.lastOffset * -1}px, 0)` },
        { transform: `translate3d(0, -100%, 0)` }
      ], { ...animationOptions3, duration: 700 }).finished;
    } else {
      await Promise.all([
        this.contentContainerRef.value.animate([
          { transform: `translate3d(0, ${this.lastOffset}px, 0)` },
          { transform: `translate3d(0, 100%, 0)` }
        ], { duration: 1e3 }).finished,
        this.touchContainerRef.value.animate([
          { opacity: 1 },
          { opacity: 0 }
        ], { ...animationOptions3, duration: 1e3 }).finished,
        this.backgroundViewRef.value.animate([
          getBackdropFilter("blur(3px)"),
          getBackdropFilter("blur(0px)")
        ], { ...animationOptions3, duration: 1e3 })
      ]);
    }
  }
  swipeDownOnShortViewHandler() {
    let fullView = this.fullView;
    return merge2(
      this.openInterpolation$,
      getInteractiveTouchEvent(this, {
        startHandler: () => {
          fullView = this.fullView;
          this.hostHeight = this.clientHeight;
          this.animationStartHandler();
        },
        endHandler: () => {
          this.animationCompleteHandler();
        }
      })
    ).pipe(
      map3((offset) => {
        return this.fullView && offset < this.infoViewHeight ? this.infoViewHeight : offset;
      }),
      tap3((offset) => {
        if (!this.touchContainerRef.value || this.scrollTop > 0 || this.closeInProgress) return;
        if (offset < 0) {
          this.handleCloseOnShortView(offset);
        } else {
          this.applyBackgroundBlur(offset);
          this.applyOffsetOnContentContainer(offset);
          this.applyOffsetOnShowAll(offset);
          this.applyHostHeight(offset);
          this.handleCloseOnFullView(offset, fullView);
        }
        this.applyOffsetOnHost(offset);
        this.lastOffset = offset;
      })
    );
  }
  getUpButtonTemplate() {
    return html7`
      <inch-button @click="${() => this.scrollToUp()}" size="l">
        <inch-icon style="transform: rotate(180deg)" icon="arrowDown24"></inch-icon>
      </inch-button>
    `;
  }
  onShowHideUpButton() {
    return fromEvent3(this, "scroll").pipe(
      startWith2(null),
      map3(() => {
        return this.scrollTop > 80;
      }),
      distinctUntilChanged2(),
      debounceTime2(300),
      switchMap4(async (state3) => {
        if (state3) {
          this.upButtonElement?.remove();
          this.upButtonElement = document.createElement("div");
          render(this.getUpButtonTemplate(), this.upButtonElement);
          appendStyle5(this.upButtonElement, {
            position: "fixed",
            bottom: "16px",
            right: "16px",
            zIndex: "3010",
            transform: "translateY(200%)"
          });
          getContainer().appendChild(this.upButtonElement);
          await this.upButtonElement?.animate([
            { transform: "translateY(200%)" },
            { transform: "translateY(0)" }
          ], animationOptions3).finished;
          if (this.upButtonElement === null) return;
          appendStyle5(this.upButtonElement, {
            transform: ""
          });
        } else {
          await this.upButtonElement?.animate([
            { transform: "translateY(0)" },
            { transform: "translateY(200%)" }
          ], animationOptions3).finished;
          this.upButtonElement?.remove();
          this.upButtonElement = null;
        }
        return [];
      })
    );
  }
  applyBackgroundBlur(offset) {
    if (!this.backgroundViewRef.value || this.fullView) return;
    const max = 3;
    let blur = offset * max / this.infoViewHeight;
    blur = blur > max ? max : blur;
    appendStyle5(this.backgroundViewRef.value, {
      ...getBackdropFilter(`blur(${blur}px)`)
    });
  }
  applyOffsetOnContentContainer(offset) {
    if (!this.contentContainerRef.value) return;
    const contentContainerOffset = offset - this.infoViewHeight;
    if (contentContainerOffset >= 0) {
      appendStyle5(this.contentContainerRef.value, {
        transform: `translate3d(0, ${contentContainerOffset}px, 0)`
      });
    }
  }
  applyOffsetOnShowAll(offset) {
    if (offset >= this.infoViewHeight && !this.fullView) {
      this.onShowAll();
    }
  }
  applyOffsetOnHost(offset) {
    let hostOffset = this.infoViewHeight - offset;
    hostOffset = Math.max(hostOffset, 0);
    appendStyle5(this, {
      transform: hostOffset === 0 ? "" : `translate3d(0, -${hostOffset}px, 0)`
    });
  }
  applyHostHeight(offset) {
    const max = window.innerHeight;
    const min = this.hostHeight;
    let height = offset * max / this.infoViewHeight;
    height = height > max ? max : height;
    height = height < min ? min : height;
    appendStyle5(this, {
      height: `${height}px`
    });
  }
  handleCloseOnShortView(offset) {
    if (offset < -(this.hostHeight * 0.25)) {
      this.controller.closeNotifications().catch(console.error);
    }
  }
  handleCloseOnFullView(offset, fullView) {
    if (offset > 30 * window.innerHeight / 100 && fullView) {
      this.controller.closeNotifications().catch(console.error);
    }
  }
  scrollToUp() {
    this.scrollTo({ top: -1, left: 0, behavior: "smooth" });
  }
};
NotificationsMobileContainerElement.tagName = "inch-notifications-mobile-container";
NotificationsMobileContainerElement.styles = [
  getScrollbarStyle2(":host", true),
  notificationsBaseContainerStyle,
  notificationsMobileContainerStyle
];
__decorateClass([
  consume2({ context: ApplicationContextToken2 })
], NotificationsMobileContainerElement.prototype, "applicationContext", 2);
NotificationsMobileContainerElement = __decorateClass([
  customElement4(NotificationsMobileContainerElement.tagName)
], NotificationsMobileContainerElement);
function getInteractiveTouchEvent(element, config) {
  const end$ = fromEvent3(document, "touchend");
  return fromEvent3(element, "touchstart").pipe(
    switchMap4((startEvent) => {
      config?.startHandler?.();
      const startPoint = startEvent.touches[0].clientY;
      return fromEvent3(document, "touchmove").pipe(
        map3((event) => event.touches[0].clientY - startPoint),
        switchMap4((offset) => end$.pipe(
          switchMap4(() => {
            config?.endHandler?.();
            return interpolateTo(offset, 0, 500);
          }),
          startWith2(offset)
        )),
        takeUntil3(end$.pipe(debounceTime2(600)))
      );
    })
  );
}
function cubicBezier(p1y, p2y) {
  return (t) => {
    const u = 1 - t;
    const tt = t * t;
    const uu = u * u;
    const uuu = uu * u;
    const ttt = tt * t;
    return uuu * 0 + 3 * uu * t * p1y + 3 * u * tt * p2y + ttt * 1;
  };
}
function cubicBezierInterpolation(p1y, p2y) {
  const ease2 = cubicBezier(p1y, p2y);
  return (startValue, endValue, t) => {
    const bezierValue = ease2(t);
    return startValue + (endValue - startValue) * bezierValue;
  };
}
var ease = cubicBezierInterpolation(0, 0.8);
function interpolateTo(fromValue, toValue, duration) {
  return new Observable2((subscriber) => {
    const startTime = Date.now();
    const endTime = startTime + duration;
    let timer2;
    const handler = () => {
      const currentTime = Date.now();
      const elapsedTime = currentTime - startTime;
      const t = Math.min(elapsedTime / duration, 1);
      const currentValue = ease(fromValue, toValue, t);
      subscriber.next(currentValue);
      if (currentTime < endTime) {
        timer2 = requestAnimationFrame(handler);
      } else {
        subscriber.complete();
      }
    };
    timer2 = requestAnimationFrame(handler);
    return () => {
      timer2 && cancelAnimationFrame(timer2);
    };
  });
}
function getBackdropFilter(value) {
  return {
    backdropFilter: value,
    "-webkit-backdrop-filter": value
  };
}

// libs/widgets/src/lib/notifications/notifications-controller.ts
import { getMobileMatchMedia } from "@one-inch-community/core/lit";
import { LongTimeAsyncCache } from "@one-inch-community/core/cache";

// libs/widgets/src/lib/notifications/notifications-id.ts
import { genRandomHex } from "@one-inch-community/core/random";
function getNotificationId() {
  return genRandomHex(10);
}

// libs/widgets/src/lib/notifications/notifications-controller.ts
import { getContainer as getContainer2 } from "@one-inch-community/ui-components/overlay";
import { distinctUntilChanged as distinctUntilChanged3, map as map4, startWith as startWith3, Subject as Subject2 } from "rxjs";
import { asyncFrame } from "@one-inch-community/core/async";
var NotificationsController = class {
  constructor() {
    this.cache = new LongTimeAsyncCache("notifications", 3);
    this.notifications = /* @__PURE__ */ new Map();
    this.mobileMatchMedia = getMobileMatchMedia();
    this.activeContainer = null;
    this.update$ = new Subject2();
    this.notificationsCount$ = this.update$.pipe(
      startWith3(null),
      map4(() => this.notifications.size),
      distinctUntilChanged3()
    );
  }
  async init() {
    const records = await this.cache.getAll();
    for (const record of records) {
      const notification = JSON.parse(record);
      const templateElement = document.createElement("template");
      templateElement.innerHTML = notification.template.trim();
      const element = templateElement.content.firstChild;
      this.notifications.set(notification.id, {
        ...notification,
        element
      });
    }
    this.update$.next();
  }
  async openAllNotifications() {
    const container = this.getNotificationsContainer();
    if (!getContainer2().contains(container)) {
      await this.renderContainer();
    }
    container.openAll();
  }
  async closeNotifications() {
    const container = this.getNotificationsContainer();
    await container.preClose();
    container.remove();
    this.activeContainer = null;
    this.update$.next();
  }
  async removeNotifications() {
    this.notifications.clear();
    await this.cache.clear();
    await this.closeNotifications();
    this.update$.next();
  }
  async removeNotification(id) {
    if (!this.notifications.has(id)) return;
    this.notifications.delete(id);
    await this.cache.delete(id);
    if (this.notifications.size === 0) {
      await this.closeNotifications();
      return;
    }
    const container = this.getNotificationsContainer();
    if (getContainer2().contains(container)) {
      container.setAllNotifications(this.getSortedNotifications());
    } else {
      await this.renderContainer();
    }
    this.update$.next();
  }
  async error(template) {
    return await this.show(
      "Error",
      template,
      { errorStyle: true }
    );
  }
  async warning(template) {
    return await this.show(
      "Warning",
      template,
      { warningStyle: true }
    );
  }
  async show(title, template, config) {
    return await this.render(template, { ...config, title });
  }
  async render(template, config) {
    const id = getNotificationId();
    const templateResult = typeof template === "string" ? html8`${template}` : template;
    const element = document.createElement("div");
    render2(templateResult, element);
    await asyncFrame();
    const record = {
      id,
      element,
      config: config ?? {},
      timestamp: Date.now()
    };
    this.notifications.set(id, record);
    if (!(config?.notCache ?? false)) {
      await this.cacheNotification(id, record);
    }
    const container = this.getNotificationsContainer();
    if (getContainer2().contains(container)) {
      container.setAllNotifications(this.getSortedNotifications());
    } else {
      await this.renderContainer();
    }
    this.update$.next();
    return id;
  }
  async renderContainer() {
    const container = this.getNotificationsContainer();
    container.setAllNotifications(this.getSortedNotifications());
    await container.preRender();
    getContainer2().appendChild(container);
    await container.postRender();
    this.update$.next();
  }
  getNotificationsContainer() {
    if (this.activeContainer !== null) {
      return this.activeContainer;
    }
    let container;
    if (this.mobileMatchMedia.matches) {
      container = document.createElement(NotificationsMobileContainerElement.tagName);
    } else {
      container = document.createElement(NotificationsDesktopContainerElement.tagName);
    }
    container.setController(this);
    this.activeContainer = container;
    return container;
  }
  async cacheNotification(id, record) {
    try {
      const serializer = new XMLSerializer();
      const templateString = serializer.serializeToString(record.element);
      const recordString = JSON.stringify({
        ...record,
        template: templateString,
        element: void 0
      });
      await this.cache.set(id, recordString);
    } catch (error) {
      console.warn(error);
    }
  }
  getSortedNotifications() {
    return [...this.notifications.entries()].sort((r1, r2) => {
      const n1 = r1[1];
      const n2 = r2[1];
      return n2.timestamp - n1.timestamp;
    });
  }
};

// libs/widgets/src/lib/notifications/elements/notifications-open-button/notifications-open-button.element.ts
import { html as html9, LitElement as LitElement4 } from "lit";
import { customElement as customElement5, state } from "lit/decorators.js";
import "@one-inch-community/ui-components/button";
import "@one-inch-community/ui-components/icon";
import { consume as consume3 } from "@lit/context";
import { ApplicationContextToken as ApplicationContextToken3 } from "@one-inch-community/core/application-context";

// libs/widgets/src/lib/notifications/elements/notifications-open-button/notifications-open-button.style.ts
import { css as css6 } from "lit";
var notificationsOpenButtonStyle = css6`

    :host {
        position: relative;
    }
    
    .notification-counter {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 8px;
        background-color: var(--color-background-bg-info);
        border-radius: 8px;
        min-width: 10px;
        height: 12px;
        display: flex;
        padding-left: 2px;
        padding-right: 2px;
        justify-content: center;
        align-items: center;
        color: var(--color-content-content-primary);
        pointer-events: none;
    }
`;

// libs/widgets/src/lib/notifications/elements/notifications-open-button/notifications-open-button.element.ts
import { defer as defer2, tap as tap4 } from "rxjs";
import { subscribe as subscribe5 } from "@one-inch-community/core/lit";
import { when } from "lit/directives/when.js";
import { ifDefined } from "lit/directives/if-defined.js";
var NotificationsOpenButtonElement = class extends LitElement4 {
  constructor() {
    super(...arguments);
    this.count = 0;
    this.count$ = defer2(() => this.applicationContext.notificationsController.notificationsCount$);
  }
  firstUpdated() {
    this.count = this.applicationContext.storageController.get("inch-notifications-open-button__count", Number) ?? 0;
    subscribe5(this, [
      this.count$.pipe(tap4((count) => {
        this.applicationContext.storageController.set("inch-notifications-open-button__count", count);
        this.count = count;
      }))
    ]);
  }
  render() {
    return html9`
      <inch-button disabled="${ifDefined(this.count === 0 ? "" : void 0)}" @click="${() => this.applicationContext.notificationsController.openAllNotifications()}" size="l" type="primary-gray">
        <inch-icon icon="bell24"></inch-icon>
      </inch-button>
      ${when(this.count, () => html9`
        <span class="notification-counter">${this.count}</span>
      `)}
    `;
  }
};
NotificationsOpenButtonElement.tagName = "inch-notifications-open-button";
NotificationsOpenButtonElement.styles = [
  notificationsOpenButtonStyle
];
__decorateClass([
  consume3({ context: ApplicationContextToken3 })
], NotificationsOpenButtonElement.prototype, "applicationContext", 2);
__decorateClass([
  state()
], NotificationsOpenButtonElement.prototype, "count", 2);
NotificationsOpenButtonElement = __decorateClass([
  customElement5(NotificationsOpenButtonElement.tagName)
], NotificationsOpenButtonElement);

// libs/widgets/src/lib/notifications/elements/notification-fusion-swap-view/notification-fusion-swap-view.element.ts
import { html as html10, LitElement as LitElement5 } from "lit";
import { customElement as customElement6, property as property2, state as state2 } from "lit/decorators.js";

// libs/widgets/src/lib/notifications/elements/notification-fusion-swap-view/notification-fusion-swap-view.styles.ts
import { css as css7 } from "lit";
var notificationFusionSwapViewStyles = css7`

    .loading-view {
        display: flex;
        gap: 8px;
        align-items: center;
        min-height: 38px;
    }

    .loader {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid;
        border-bottom-color: var(--secondary);
        border-top-color: var(--secondary);
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
    
    .status-view-container {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
    }
    
    .token-icon-container {
        grid-row: 1 / span 2;
        position: relative;
        height: 34px;
        width: 34px;
        min-width: 34px;
    }
    
    .source-token-icon {
        display: block;
    }
    
    .destination-token-icon {
        position: absolute;
        display: block;
        top: 10px;
        right: 0;
    }
    
    .amount-status-view {
        font-size: 14px;
        color: var(--color-content-content-primary);
    }
    
    .symbol-view {
        font-size: 12px;
        color: var(--color-content-content-secondary);
    }
    
    .status-container {
        margin-top: 4px;
        display: flex;
        align-items: center;
        font-size: 11px;
        gap: 4px;
    }
    
    .status-view {
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: fit-content;
        padding: 2px 6px;
    }
    
    .status-view__pending {
        background-color: var(--primary-50);
    }  
    
    .status-view__partially-filled {
        background-color: var(--primary-50);
    }

    .status-view__filled,
    .status-view__cancelled {
        background-color: var(--color-background-bg-info);
    }

    .status-view__expired {
        background-color: var(--color-background-bg-warning);
    }

    .status-view__not-enough-balance-or-allowance,
    .status-view__wrong-permit,
    .status-view__invalid-signature,
    .status-view__false-predicate {
        background-color: var(--color-background-bg-critical);
    }
    
    .cancel-button {
        margin-left: auto;
    }

    .cancel-button:dir(rtl) {
        margin-left: 0;
        margin-right: auto;
    }
    
    .swap-info-container {
        width: 100%;
    }
`;

// libs/widgets/src/lib/notifications/elements/notification-fusion-swap-view/notification-fusion-swap-view.element.ts
import { formatUnits } from "viem";
import { Task, TaskStatus } from "@lit/task";
import { consume as consume4 } from "@lit/context";
import { ApplicationContextToken as ApplicationContextToken4 } from "@one-inch-community/core/application-context";
import { ifDefined as ifDefined2 } from "lit/directives/if-defined.js";
import { smartFormatNumber } from "@one-inch-community/core/formatters";
import { classMap as classMap2 } from "lit/directives/class-map.js";
import { when as when2 } from "lit/directives/when.js";
import { subscribe as subscribe6, translate } from "@one-inch-community/core/lit";
import { getBlockEmitter } from "@one-inch-community/sdk/chain";
import { tap as tap5 } from "rxjs";
import("@one-inch-community/widgets/token-icon");
import("@one-inch-community/ui-components/timer");
import("@one-inch-community/ui-components/button");
var NotificationFusionSwapViewElement = class extends LitElement5 {
  constructor() {
    super(...arguments);
    this.cancelInProgress = false;
    this.task = new Task(
      this,
      async ([orderHash]) => {
        const chainId = this.chainId ?? await this.applicationContext.connectWalletController.data.getChainId();
        if (!chainId || !orderHash) throw new Error("");
        if (!this.chainId) {
          this.startUpdate(chainId);
        }
        this.chainId = chainId;
        const status = await this.applicationContext.oneInchDevPortalAdapter.getFusionOrderStatus(chainId, orderHash);
        if ("statusCode" in status) {
          throw status;
        }
        if (this.task.value !== void 0) {
          const sourceToken2 = this.task.value[1];
          const destinationToken2 = this.task.value[2];
          return [status, sourceToken2, destinationToken2];
        }
        const [sourceToken, destinationToken] = await Promise.all([
          this.applicationContext.tokenController.getToken(chainId, status.order.makerAsset),
          this.applicationContext.tokenController.getToken(chainId, status.order.takerAsset)
        ]);
        return [status, sourceToken, destinationToken];
      },
      () => [this.orderHash]
    );
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.chainId) {
      this.startUpdate(this.chainId);
    }
  }
  render() {
    return this.task.render({
      complete: ([status, sourceToken, destinationToken]) => this.onCompleteView(
        status,
        sourceToken,
        destinationToken
      ),
      pending: () => this.onPendingView(),
      error: (error) => this.onErrorView(error)
    });
  }
  onCompleteView(status, sourceToken, destinationToken) {
    const chainId = this.chainId;
    if (!sourceToken || !destinationToken || !chainId) return html10``;
    const sourceTokenAmount = BigInt(status.order.makingAmount);
    const destinationTokenAmount = BigInt(status.order.takingAmount);
    return html10`
      <div class="status-view-container">
        <div class="token-icon-container">
          <inch-token-icon
            class="source-token-icon"
            symbol="${ifDefined2(sourceToken?.symbol)}"
            address="${ifDefined2(sourceToken?.address)}"
            .chainId="${chainId}"
          ></inch-token-icon>
          <inch-token-icon
            class="destination-token-icon"
            symbol="${ifDefined2(destinationToken?.symbol)}"
            address="${ifDefined2(destinationToken?.address)}"
            .chainId="${chainId}"
          ></inch-token-icon>
        </div>
        <div class="swap-info-container">
          <div class="amount-status-view">
            ${smartFormatNumber(formatUnits(sourceTokenAmount, sourceToken.decimals), 2)}
            <span class="symbol-view">${sourceToken?.symbol}</span>
            →
            ${smartFormatNumber(formatUnits(destinationTokenAmount, destinationToken.decimals), 2)}
            <span class="symbol-view">${destinationToken?.symbol}</span>
          </div>
          <div class="swap-status-view">
            ${this.getStatusView(status)}
          </div>
        </div>
      </div>
    `;
  }
  onPendingView() {
    if (this.task.value) return this.onCompleteView(...this.task.value);
    return html10`
      <div class="loading-view">
        <div class="loader"></div>
        <div>Update order status</div>
      </div>
    `;
  }
  onErrorView(error) {
    if (typeof error === "object" && error !== null && "statusCode" in error && typeof error.statusCode === "number" && error.statusCode >= 400 && error.statusCode < 500) {
      return html10`
      <div class="error-view">
        <div>Swap not found</div>
      </div>
    `;
    }
    return html10`
      <div class="error-view">
        <div>Error load swap status</div>
      </div>
    `;
  }
  getStatusView(status) {
    const statusText = status.status;
    const classes = {
      "status-view": true,
      ["status-view__" + statusText]: true
    };
    const expirationTime = (status.auctionStartDate + status.auctionDuration) * 1e3;
    return html10`
      <div class="status-container">
        <div class="${classMap2(classes)}">
          ${translate(`widgets.notifications.fusion-swap-view.status.${statusText}`)}
        </div>
        ${when2(statusText === "pending" /* Pending */ || statusText === "partially-filled" /* PartiallyFilled */, () => html10`
          <span><inch-timer expirationTime="${expirationTime}"></inch-timer></span>
          <inch-button
            class="cancel-button"
            size="s"
            type="secondary-critical"
            loader="${ifDefined2(this.cancelInProgress ? "" : void 0)}"
            @click="${async () => {
      this.cancelInProgress = true;
      await this.applicationContext.oneInchDevPortalAdapter.cancelFusionOrder(this.chainId, this.orderHash).catch(() => null);
      await this.task.run([this.orderHash]);
    }}"
          >${translate("widgets.notifications.fusion-swap-view.control.cancel")}</inch-button>
        `)}
      </div>
    `;
  }
  startUpdate(chainId) {
    subscribe6(this, [
      getBlockEmitter(chainId).pipe(
        tap5(() => {
          if (this.task.status !== TaskStatus.COMPLETE || !this.task.value) return;
          const status = this.task.value[0];
          if (status.status !== "pending" /* Pending */ && status.status !== "partially-filled" /* PartiallyFilled */) return;
          this.task.run([this.orderHash]).catch(console.error);
        })
      )
    ], { requestUpdate: false });
  }
};
NotificationFusionSwapViewElement.tagName = "inch-notification-fusion-swap-view";
NotificationFusionSwapViewElement.styles = notificationFusionSwapViewStyles;
__decorateClass([
  property2({ type: String })
], NotificationFusionSwapViewElement.prototype, "orderHash", 2);
__decorateClass([
  consume4({ context: ApplicationContextToken4 })
], NotificationFusionSwapViewElement.prototype, "applicationContext", 2);
__decorateClass([
  state2()
], NotificationFusionSwapViewElement.prototype, "cancelInProgress", 2);
NotificationFusionSwapViewElement = __decorateClass([
  customElement6(NotificationFusionSwapViewElement.tagName)
], NotificationFusionSwapViewElement);
export {
  NotificationFusionSwapViewElement,
  NotificationsController,
  NotificationsOpenButtonElement
};
//# sourceMappingURL=index.esm.js.map
